import { InjectionToken } from '@angular/core';

export const WEBSITE_CODE = new InjectionToken<string>(
  '[Travel] theme config',
);
